<template>
    <div class="embed-responsive aspect-ratio-16/9 rounded-xl">
        <iframe class="embed-responsive-item youtube-embed rounded-xl"
            :src="`https://www.youtube.com/embed/${id}?enablejsapi=1&version=3&playerapiid=ytplayer&rel=0`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
        </iframe>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true
        }
    }
}
</script>
